import { create } from "zustand";

export type SyncStatus = "idle" | "syncing" | "error" | "offline";

interface SyncState {
  status: SyncStatus;
  pendingCount: number;
  lastError: string | null;
  lastSyncAt: string | null;
  setStatus: (status: SyncStatus) => void;
  setPendingCount: (n: number) => void;
  setLastError: (err: string | null) => void;
  setLastSyncAt: (at: string | null) => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  status: "idle",
  pendingCount: 0,
  lastError: null,
  lastSyncAt: null,
  setStatus: (status) => set({ status }),
  setPendingCount: (pendingCount) => set({ pendingCount }),
  setLastError: (lastError) => set({ lastError }),
  setLastSyncAt: (lastSyncAt) => set({ lastSyncAt }),
}));
